import React from 'react';
import { Box, Container, Typography, Link } from '@mui/material';

const Footer = () => {
  return (
    <Box component="footer" className="bg-gray-800 text-white py-4 mt-auto">
      <Container>
        <Box className="flex flex-col md:flex-row justify-between items-center">
          <Typography variant="body2" className="mb-2 md:mb-0">
            &copy; {new Date().getFullYear()} 每日冷知識 | 版權所有
          </Typography>
          <Box className="flex gap-4">
            <Link href="#" color="inherit" className="hover:text-primary-light">
              關於我們
            </Link>
            <Link href="#" color="inherit" className="hover:text-primary-light">
              隱私政策
            </Link>
            <Link href="#" color="inherit" className="hover:text-primary-light">
              聯絡我們
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
